import { StandardEvents } from '@shopify/events';

// Preserve Fabric's variant and cart lifecycle; only expose a clear next action.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add' || !event.promise) return;
  event.promise.then(({ detail }) => {
    if (detail?.didError) return;
    const product = event.target instanceof Element ? event.target.closest('product-component') : null;
    for (const link of product?.querySelectorAll('[data-yh-view-cart]') ?? []) link.hidden = false;
  }).catch(() => { /* Fabric owns cart error messaging. */ });
});

// Each matching garment submits its own selected variant; standard forms remain a fallback.
document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('.yh-matching__form')) return;
  event.preventDefault();
  if (!form.reportValidity()) return;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('.yh-matching__status');
  if (button.disabled) return;
  button.disabled = true;
  const data = new FormData(form);
  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
      method: 'POST', headers: { Accept: 'application/json' }, body: data,
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || 'This size could not be added. Please try another.');
    // Navigate to the authoritative cart so totals, stock, Route, and wallet components render together.
    window.location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
  } catch (error) {
    status.textContent = error.message || 'Unable to add this item. Please try again.';
    button.disabled = false;
  }
});

// Let Fabric keep filter URLs and density. Remember the exact shopping scroll position.
const browseKey = () => `yh-browse:${location.pathname}${location.search}`;
const browseScroller = () => {
  const wrapper = document.querySelector('.page-wrapper');
  return wrapper && wrapper.scrollHeight > wrapper.clientHeight + 100 ? wrapper : document.scrollingElement;
};
if (document.body.matches('.yh-template-collection, .yh-template-search')) {
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || !new URL(link.href, location.href).pathname.includes('/products/')) return;
    try { sessionStorage.setItem(browseKey(), String(browseScroller().scrollTop)); } catch { /* Storage may be unavailable. */ }
  });
  window.addEventListener('pageshow', () => {
    if (performance.getEntriesByType('navigation')[0]?.type !== 'back_forward') return;
    try {
      const position = Number(sessionStorage.getItem(browseKey()));
      if (position > 0) requestAnimationFrame(() => browseScroller().scrollTo({ top: position, behavior: 'instant' }));
    } catch { /* Browser restoration remains the fallback. */ }
  });
}

// Audio is requested only when a visitor chooses to listen.
document.addEventListener('click', (event) => {
 const button = event.target instanceof Element ? event.target.closest('[data-yh-load-sounds]') : null;
 if (!button) return;
 const target = document.getElementById(button.dataset.yhLoadSounds);
 if (!target || target.querySelector('iframe')) return;
 const frame = document.createElement('iframe');
 frame.src = target.dataset.src;
 frame.title = 'Your Highness sounds on SoundCloud';
 frame.width = '100%'; frame.height = '300'; frame.setAttribute('allow', 'autoplay');
 frame.style.border = '0'; target.append(frame); button.hidden = true;
});

// One shopping choice for equivalent size labels, retaining Shopify's original URL values.
function harmonizeSizeFilters() {
  for (const list of document.querySelectorAll('ul.facets__inputs-list')) {
    const sizes = [...list.querySelectorAll('input[type="checkbox"]')].filter((input) => input.name.toLowerCase().endsWith('.size'));
    for (const aliases of [['2XL', 'XXL'], ['3XL', 'XXXL']]) {
      const group = sizes.filter((input) => aliases.includes(input.value.toUpperCase()));
      if (group.length < 2) continue;
      const primary = group.find((input) => !input.disabled && input.value.toUpperCase() === aliases[0]) || group.find((input) => !input.disabled) || group[0];
      primary.dataset.yhSizeAliases = aliases.join(',');
      const label = list.querySelector(`label[for="${CSS.escape(primary.id)}"]`);
      const text = label?.querySelector('.checkbox__label-text') || label;
      const title = `${aliases[0]} / ${aliases[1]}`;
      if (text && text.textContent.trim() !== title) text.textContent = title;
      if (group.some((input) => input.checked)) primary.checked = true;
      for (const input of group) { if (input !== primary) input.closest('li').hidden = true; }
    }
  }
}
window.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.dataset.yhSizeAliases) return;
  const aliases = input.dataset.yhSizeAliases.split(',');
  for (const other of input.closest('ul').querySelectorAll('input[type="checkbox"]')) {
    if (other.name === input.name && aliases.includes(other.value.toUpperCase())) other.checked = input.checked;
  }
}, true);
harmonizeSizeFilters();
let sizeFilterFrame = 0;
new MutationObserver((mutations) => {
  if (!mutations.some((mutation) => [...mutation.addedNodes].some((node) => node instanceof Element))) return;
  cancelAnimationFrame(sizeFilterFrame);
  sizeFilterFrame = requestAnimationFrame(harmonizeSizeFilters);
}).observe(document.querySelector('#MainContent') || document.body, { childList: true, subtree: true });
